// extracted by mini-css-extract-plugin
export default {"rolesContainer":"UserInvite_rolesContainer__EUSbK","rolesItem":"UserInvite_rolesItem__8eXxI"};